import { Sparkles } from 'lucide-react';
import { ProgressBar, Typography } from '../../symphony/ui';
import { useTranslation } from '../../../lib/i18n';
import { formatFreeUntil } from '../../../lib/free-usage';
import styles from './FreeUsageNotice.module.css';

/**
 * "Free until Oct 14, 3:00 PM" over an EMPTY meter — the plan card's credits block while promo free
 * hours are running. The drawer's own credits card draws the same empty bar
 * (`use-credits-summary`'s `fraction = freeUntil ? 0 : …`); a card that is a plan name over a meter
 * reads as a failed load when the meter goes away entirely.
 *
 * NO usage line, deliberately: the period pool is not being drawn down, so "0 of 500 used" would be a
 * claim about an allowance that is not in play.
 *
 * The bar lives here rather than in each card because the gate is exactly this component's own
 * `untilIso`, and a copy per card is two places for the two Settings surfaces to disagree.
 */
export function FreeUsageNotice({ untilIso }: { untilIso: string | null }) {
  const { t, i18n } = useTranslation();
  if (!untilIso) return null;
  return (
    <div className={styles.block} data-testid="settings-free-usage">
      <div className={styles.row}>
        <Sparkles className={styles.glyph} size={16} aria-hidden />
        <Typography variant="h4" component="span">
          {t('credits.freeUntil', { date: formatFreeUntil(untilIso, i18n.language) })}
        </Typography>
      </div>
      <ProgressBar progress="neutral" value={0} decorative />
    </div>
  );
}
